// Turns off zod's JIT for the browser. zod compiles object parsers with `new Function`, and every
// object schema probes for it when it is built; under the web app's CSP (`script-src 'self'`, no
// `unsafe-eval`) that probe is a CSP violation. The web bundle carries the contracts (the in-memory
// twin and a few shared constants import them), so its entry imports this module first, before
// any schema is built. Parsing stays the same, only without generated code. The API keeps the JIT.
import { config } from "zod";

config({ jitless: true });
